module.exports = __webpack_public_path__ + "img/5.b80f7636.png";